<div class="flex flex-col h-full bg-background rounded-xl">
  <div class="p-6 overflow-y-auto">
    
    <div class="mb-6 p-4 bg-surface rounded-lg border border-border">
      <div class="flex justify-between items-center mb-2">
        <app-text variant="muted" size="sm">Total Invoice Amount</app-text>
        <span class="font-medium">{{ invoice.totalAmount | currency }}</span>
      </div>
      <div class="flex justify-between items-center mb-2">
        <app-text variant="muted" size="sm">Factoring Fee</app-text>
        <span class="font-medium text-danger">-{{ (invoice.feeAmount || 0) | currency }}</span>
      </div>
      <div class="flex justify-between items-center">
        <app-text variant="muted" size="sm">Current Balance Due</app-text>
        <span class="font-medium text-warning">{{ ((invoice.totalAmount || 0) - (invoice.feeAmount || 0) - (invoice.receivedAmount || 0)) | currency }}</span>
      </div>
    </div>

    <form [formGroup]="form" class="space-y-4">
      <app-form-field label="Payment Amount" hint="Enter the total amount received">
        <app-number-input
          formControlName="amount"
          placeholder="0.00"
          [min]="0">
        </app-number-input>
      </app-form-field>

      <app-form-field label="Payment Status" hint="Select the new status of this invoice">
        <app-select
          formControlName="status"
          [options]="[
            { value: 'paid', label: 'Fully Paid' },
            { value: 'partially_paid', label: 'Partially Paid' },
            { value: 'overpaid', label: 'Overpaid' },
            { value: 'problematic', label: 'Problematic' }
          ]"
        ></app-select>
      </app-form-field>
    </form>
    
  </div>
  
  <div class="p-6 border-t border-border flex justify-end gap-3 bg-surface rounded-b-xl">
    <app-button variant="outline" (click)="close()">Cancel</app-button>
    <app-button variant="primary" (click)="save()" [disabled]="form.invalid || isSaving()">
      @if (isSaving()) {
        <lucide-icon name="loader-2" class="w-4 h-4 animate-spin mr-2"></lucide-icon>
        Recording...
      } @else {
        Record Payment
      }
    </app-button>
  </div>
</div>
